module.exports = __webpack_public_path__ + "img/banner.2bd9b496.png";